import { version } from '@app/package.json';
import './Version.scss';

interface Props {
  finchVersion: string;
}

const Version = ({ finchVersion }: Props): JSX.Element => (
  <div className="versionsInfo">
    <div className="finchVersion">
      <p>
        {finchVersion}
        ..
        {version}
      </p>
    </div>
  </div>
);

export default Version;
